import { Link } from "react-router-dom";
import { Truck } from "lucide-react";
import { Reveal } from "./Reveal";

export const DoorstepBand = () => (
  <section data-testid="doorstep-band" className="px-4 sm:px-8 py-10">
    <Reveal className="max-w-[1400px] mx-auto rounded-[32px] bg-[#BDE3FA] px-6 sm:px-12 py-10 flex flex-col md:flex-row md:items-center gap-6 md:gap-10">
      <div className="h-16 w-16 shrink-0 rounded-2xl bg-white grid place-items-center">
        <Truck className="h-8 w-8 text-[#FF5A5F]" />
      </div>
      <div className="flex-1">
        <h2 className="font-display text-3xl sm:text-5xl leading-[0.95]">Delivered right to your doorstep.</h2>
        <p className="mt-3 text-base sm:text-lg text-[#1B1530]/80">Free shipping on orders over $100.</p>
      </div>
      <Link to="/build?size=12" data-testid="doorstep-cta" className="h-12 px-7 rounded-full bg-[#1B1530] text-white font-bold inline-flex items-center justify-center hover:bg-[#FF5A5F] transition-colors shrink-0">Build my box</Link>
    </Reveal>
  </section>
);
